import { Select, Text, VStack } from "@chakra-ui/react";
import { useState } from "react";
import { useStores } from "../../store/store_context";
import { observer } from "mobx-react-lite";

const SelectGroupBy = observer(() => {
  const { pageStore } = useStores();
  return (
    <VStack>
      <Select
        style={{
          border: "none",
          background: "#333",
          color: "#EEEEEE",
          borderRadius: "10px",
          fontWeight: 600,
        }}
        width={"250px"}
        fontSize={"14px"}
        value={pageStore.year_or_mouth_view_mops}
        onChange={(e) => {
          const selectedValue = e.target.value;
          pageStore.updateYearOrMouthViewMOPS(selectedValue);
        }}
      >
        <option value="month" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Группировка по месяцу</option>
        <option value="year" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Группировка по году</option>
      </Select>
    </VStack>
  );
})

export default SelectGroupBy;
